import { t } from '@if/core/i18n'
import { EPaymentPlan } from '@if/core/types'
import * as yup from '@if/core/yup'
import { ETerms, ETermsList } from '@src/types/Constants'

export const PersonalLoanCalculatorSchema = yup.object().shape({
  amountRequested: yup
    .integer()
    .min(500, () => t('common.errors.minimumAmount', { min: 500 }))
    .max(40000, () => t('common.errors.maximumAmount', { max: 40000 }))
    .required(),

  paymentPlanId: yup.mixed<EPaymentPlan>().required().default(EPaymentPlan.RegularDailyInterests),
  term: yup.mixed<ETerms>().oneOf(ETermsList, () => t('common.errors.invalidTerm')),
  creditScore: yup.number().min(300).max(900).required(),
  lenderFee: yup.number().default(0).required(),
  clinicFee: yup.number().default(0).required(),
})

export type PersonalLoanCalculatorSchemaType = yup.InferType<typeof PersonalLoanCalculatorSchema>
